import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/card-visa.png'
import _imports_1 from '@/assets/img/card-master.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-14712639"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "data-w-id": "448c0df2-8fda-b42f-7c4e-044c21a776a2",
  class: "contact"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "contact",
  class: "anchor is--footer"
}, null, -1))
const _hoisted_3 = { class: "w-layout-hflex global--padding" }
const _hoisted_4 = { class: "global--wrapper is--footer" }
const _hoisted_5 = { class: "footer--header" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-sep" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inner--line--right" })
], -1))
const _hoisted_8 = {
  class: "footer-contacts--wrapper",
  style: {"width":"100%"}
}
const _hoisted_9 = { class: "w-layout-vflex contact--wrapper" }
const _hoisted_10 = { class: "text--chip is--yellow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:support@swipez.eu",
  class: "contact--link w-inline-block"
}, [
  /*#__PURE__*/_createElementVNode("div", null, "support@swipez.eu"),
  /*#__PURE__*/_createElementVNode("div", { class: "link--underline" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "link--inner--lightline" })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-left:auto;max-width:220px;display:flex;align-items:center;padding-top:20px;\" data-v-14712639><div style=\"width:70px;\" data-v-14712639><img src=\"" + _imports_0 + "\" data-v-14712639></div><div style=\"width:60px;\" data-v-14712639><img src=\"" + _imports_1 + "\" data-v-14712639></div></div>", 1)
const _hoisted_13 = { class: "copy" }
const _hoisted_14 = { class: "w-layout-hflex disclaimer" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "copy-p" }, [
  /*#__PURE__*/_createTextVNode(" Copyright © 2025 Draph Solutions s.r.o. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("All Rights Reserved ")
], -1))
const _hoisted_16 = { class: "div-block-7" }
const _hoisted_17 = {
  href: "/privacy-policy",
  target: "_blank",
  class: "footer--link w-inline-block"
}
const _hoisted_18 = {
  href: "/terms-and-conditions",
  target: "_blank",
  class: "footer--link w-inline-block"
}
const _hoisted_19 = {
  href: "/complaints-disclaimer",
  class: "footer--link w-inline-block"
}
const _hoisted_20 = {
  href: "/safeguarding-disclaimer",
  class: "footer--link w-inline-block"
}
const _hoisted_21 = { class: "w-layout-hflex footer--nav" }
const _hoisted_22 = { class: "disclaimer--p" }

import LocaleSwitcher from "@/locales/LocaleSwitcher.vue";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const { locale } = useI18n();
const curLang = ref("cz");
onMounted(async () => {
  curLang.value = localStorage.getItem("locale") || "cz";
  locale.value = curLang.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", {
            class: "h--large is--white v--2",
            innerHTML: _ctx.$t('footer.NEED OUR TEAM HELP?')
          }, null, 8, _hoisted_6),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Email")), 1),
            _hoisted_11
          ]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("footer.Privacy Policy")), 1)
              ]),
              _createElementVNode("a", _hoisted_18, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("footer.Terms and Conditions")), 1)
              ]),
              _createElementVNode("a", _hoisted_19, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("footer.Complaints Disclaimer")), 1)
              ]),
              _createElementVNode("a", _hoisted_20, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t("footer.Safeguarding Disclaimer")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("footer.All rights reserved")), 1)
          ])
        ])
      ])
    ])
  ]))
}
}

})